import { Indicator } from 'client/voladeum/indicators/types';

export const filterGrid = <T extends Record<string, any>>(data: T[], filter: string): T[] => {
  const search = String(filter || '').toLowerCase();

  return data.filter((row) => {
    return Object.values(row).some((value) => {
      if (value == null) return false;
      return String(value).toLowerCase().includes(search);
    });
  });
};

export const buildIndicatorIdentifier = (indicator: Indicator): string => {
  const { identifier, parameters } = indicator;

  const params = Object.entries(parameters)
    .map(([key, value]) => `${key}_${value}`)
    .join('_');

  return params ? `${identifier}_${params}` : identifier;
};
